import { render, staticRenderFns } from "./CompanyDetailForm.vue?vue&type=template&id=4cd7c21f"
import script from "./CompanyDetailForm.vue?vue&type=script&lang=js"
export * from "./CompanyDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports